import React from 'react';
import SSOOnboardingTemplate from '../../../atomic/templates/SSOOnboardingTemplate/SSOOnboardingTemplate';

const SSOAuthorizePresentational = () => {
  return <SSOOnboardingTemplate>Authorize failed</SSOOnboardingTemplate>;
};

export default SSOAuthorizePresentational;
